;
// Carousel functionality
(() => {
  const r = document.querySelector("#customer-videos");
  if (!r) return;

  const o = r.querySelector(".cv-row"),
        p = r.querySelector(".cv-prev"),
        n = r.querySelector(".cv-next"),
        d = [...r.querySelectorAll(".cv-dot")],
        c = [...r.querySelectorAll(".cv-card")],
        m = () => matchMedia("(max-width: 999px)").matches,
        i = () => {
          const t = o.getBoundingClientRect(),
                e = t.left + t.width / 2;
          let s = 0, l = 1 / 0;
          c.forEach((a, f) => {
            const g = a.getBoundingClientRect(),
                  h = g.left + g.width / 2,
                  u = Math.abs(h - e);
            u < l && (l = u, s = f)
          });
          return s
        },
        s = t => {
          c[t] && c[t].scrollIntoView({
            behavior: "smooth",
            inline: "nearest",
            block: "nearest"
          });
          requestAnimationFrame(u)
        },
        a = e => {
          if (!m()) return;
          const t = i(),
                l = Math.min(c.length - 1, Math.max(0, t + e));
          if (l === t) return;
          s(l)
        },
        u = () => {
          if (!m()) return;
          const t = i();
          d.forEach((e, l) => e.classList.toggle("is-active", l === t));
          if (p) {
            const e = t <= 0;
            p.disabled = e;
            p.setAttribute("aria-disabled", "" + e)
          }
          if (n) {
            const e = t >= c.length - 1;
            n.disabled = e;
            n.setAttribute("aria-disabled", "" + e)
          }
        };

  p?.addEventListener("click", () => a(-1));
  n?.addEventListener("click", () => a(1));
  o?.addEventListener("scroll", () => {
    requestAnimationFrame(u)
  });
  addEventListener("resize", u);
  d.forEach((t, e) => t.addEventListener("click", () => {
    m() && s(e)
  }));
  u();
})();

// Video lazy loading and autoplay on click
(() => {
  const placeholders = document.querySelectorAll('.video-placeholder');
  if (!placeholders.length) return;

  placeholders.forEach(placeholder => {
    placeholder.addEventListener('click', function(e) {
      // Prevent multiple clicks
      if (this.classList.contains('video-loaded')) return;

      const videoSrc = this.getAttribute('data-src');

      // Create video element
      const video = document.createElement('video');
      video.className = 'cv-video';
      video.controls = true;
      video.playsInline = true;
      video.autoplay = true; // autoplay on click
      video.muted = false; // change to true if autoplay requires muted
      video.preload = 'metadata';

      const source = document.createElement('source');
      source.src = videoSrc;
      source.type = 'video/mp4';
      video.appendChild(source);

      // Hide placeholder image and play button
      const img = this.querySelector('.placeholder-image');
      if (img) img.style.display = 'none';

      const playBtn = this.querySelector('.play-button');
      if (playBtn) playBtn.style.display = 'none';

      // Append video inside placeholder
      this.appendChild(video);
      this.classList.add('video-loaded');

      // Play the video
      video.play().catch(err => {
        console.log('Autoplay blocked:', err);
      });
    });
  });
})();


;
/* Single-open behavior: opening one details closes the others */
(function(){
  var faq = document.getElementById('faq-objections');
  if(!faq) return;
  var items = faq.querySelectorAll('.faq-item');
  items.forEach(function(el){
    el.addEventListener('toggle', function(){
      if (el.open) {
        items.forEach(function(other){
          if (other !== el) other.removeAttribute('open');
        });
      }
    });
  });
})();
